export default __webpack_public_path__ + "media/images/react_icons/arrow-left-white-800f01fb6ffce039e858588ddd948286.svg";